/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_MaterialsInputs */

const vi_care_log_materials = /** @type {(inputs: Care_Log_MaterialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vật tư sử dụng`)
};

/**

* @param {Care_Log_MaterialsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_materials = /** @type {((inputs?: Care_Log_MaterialsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_MaterialsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_materials(inputs)
});